const EYE_BASE_URL = 'https://eye.snooper.app/submissions';

export default EYE_BASE_URL;
